import { defineStore } from 'pinia'
import { reactive, readonly } from 'vue'

interface ICarRentalStoreState {
	rangeValue: number
}

interface ICarRentalStore {
	readonly state: ICarRentalStoreState
	setRangeValue: (rangeValue: number) => void
	getRangeValue: ComputedRef<number>
}

export const useCarRentalStore = defineStore('carRentalStore', (): ICarRentalStore => {
	const _state = reactive<ICarRentalStoreState>({
		rangeValue: 1,
	})

	const setRangeValue = (rangeValue: number): void => {
		_state.rangeValue = rangeValue
	}

	const getRangeValue = computed(() => {
		return _state.rangeValue
	})

	return {
		state: readonly(_state),
		setRangeValue,
		getRangeValue,
	}
})
